import React, { useLayoutEffect, useMemo, useRef, useState } from 'react';
import BgModalUpgrade from '../../assets/images/bg-upgrade-success.svg';
import { px2rem } from '../../common/theme/px2rem';
import { GrowBolt } from '@menuzen/icon/build/outline';
import Dialog, { DialogProps } from '../dialog/Dialog';
import TickCheckIcon from '../icon/TickCheck';
import { Button } from '@mui/material';
import { useParams } from 'react-router';

export const PlanUpgradeSuccessModal: React.FC<DialogProps> = (props) => {
    const modalRef = useRef<HTMLDivElement | null>(null);
    const [height, setHeight] = useState(0);
    const { accountId } = useParams<{ accountId: string }>();
    const handleSubmitUpgrade = () => {
        const baseUrl = process.env.REACT_APP_CORE_APP_URL;
        window.location.href = `${baseUrl}/account/${accountId}/setting?tab=PLAN`;
    };
    useLayoutEffect(() => {
        if (modalRef.current) {
            setHeight(modalRef.current?.offsetWidth * 0.2817);
        }
    }, [modalRef.current?.offsetWidth]);
    return (
        <Dialog
            classes={{
                paper: '!pt-0',
            }}
            {...props}
            childClassName="flex flex-col flex-auto overflow-y-auto"
            headerStyle={{
                position: 'relative',
                top: 0,
                backgroundImage: `url(${BgModalUpgrade})`,
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'top left',
                width: '100%',
                height: height,
            }}
            headerClassName={'flex w-full px-28 relative shrink-0 pt-20'}
            closeButtonClassName={'flex-shrink-0 text-24 text-primary-70 absolute right-28 top-15 cursor-pointer z-10'}
            borderGradient={'px-4 pt-4 bg-gradient-upgrade-90'}
        >
            <div ref={modalRef} className={'flex flex-col flex-auto px-30 pt-20 pb-40 overflow-y-auto'}>
                <div className={'text-center'}>
                    <div
                        className={`inline-flex items-center justify-center text-white bg-gradient-upgrade-90 p-6 rounded`}
                    >
                        <GrowBolt />
                        <span className={`text-12`}>{`Grow`}</span>
                    </div>
                </div>
                <h1 className={'font-bold my-12 text-28 text-center'}>Congratulations!</h1>
                <p className={'text-center text-14 mb-12'}>
                    Thank you for upgrading to Menuzen Grow. <br />
                    You have now unlocked:
                </p>

                <div className={'p-2 rounded-6 bg-gradient-mid'}>
                    <div className={'py-10 px-15 text-12 leading-none font-semibold bg-white rounded-6 '}>
                        <div className={'flex items-center mb-8'}>
                            <div
                                className={
                                    'mr-8 flex items-center justify-center h-21 w-21 rounded-circle border border-success text-success bg-success-10 text-12'
                                }
                            >
                                <TickCheckIcon />
                            </div>
                            Unlimited Menus, Items & Users
                        </div>
                        <div className={'flex items-center mb-8'}>
                            <div
                                className={
                                    'mr-8 flex items-center justify-center h-21 w-21 rounded-circle border border-success text-success bg-success-10 text-12'
                                }
                            >
                                <TickCheckIcon />
                            </div>
                            Remove Menuzen Branding
                        </div>
                        <div className={'flex items-center mb-8'}>
                            <div
                                className={
                                    'mr-8 flex items-center justify-center h-21 w-21 rounded-circle border border-success text-success bg-success-10 text-12'
                                }
                            >
                                <TickCheckIcon />
                            </div>
                            Custom Menu Embedding
                        </div>
                        <div>...and so much more!</div>
                    </div>
                </div>
                <div className="mt-22 flex flex-col space-y-8">
                    <Button
                        className="mb-8"
                        type="button"
                        onClick={handleSubmitUpgrade}
                        variant="outlined"
                        size="large"
                    >
                        See plan details
                    </Button>
                    <Button type="button" onClick={props.onClose} variant="contained" size="large">
                        Done
                    </Button>
                </div>
            </div>
        </Dialog>
    );
};
